import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { TextmultilineComponent } from "@components/textmultiline/textmultiline.component";
import { Subscription } from "rxjs";
import { SetArbetsorderAnteckningVirkesorderCommand } from "~app/features/planera/commands/SetArbetsorderAnteckningVirkesorderCommand";
import { UpdateArbetsorderAnteckningProdplanCommand } from "~app/features/planera/commands/UpdateArbetsorderAnteckningProdplanCommand";
import * as ArbetsorderConstants from "~app/features/planera/model/ArbetsorderConstants";
import { ArbetsorderDisabledFlag } from "~app/features/planera/model/ArbetsorderDisabledFlag";
import { IArbetsorderDetail } from "~app/features/planera/model/IArbetsorderDetail";
import { IAtgard } from "~app/features/planera/model/IAtgard";
import { ArbetsorderInfoAnteckningSelection, IAnteckning } from "../arbetsorder-info-anteckningar.model";
import { ArbetsorderInfoAnteckningarService } from "../arbetsorder-info-anteckningar.service";

@Component({
    selector: "rask-arbetsorder-info-arbetsorder-anteckningar",
    templateUrl: "./arbetsorder-info-arbetsorder-anteckningar.component.html",
    styleUrls: ["./arbetsorder-info-arbetsorder-anteckningar.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextareaComponent,
        FormsModule,
        TextmultilineComponent
    ]
})

export class ArbetsorderInfoArbetsorderAnteckningarComponent implements OnInit, OnDestroy {
    anteckningar: IAnteckning[];
    arbetsorder: IArbetsorderDetail;
    arbetsorderAnteckningVirkesorderMaxLength = ArbetsorderConstants.ArbetsorderAnteckningVirkesorderMaxLength;

    // Egentligen 2000 men backend lägger på newline vilket är två tecken till
    prodPlanMaxLength = 1998;

    private readonly arbetsorderInfoAnteckningarService = inject(ArbetsorderInfoAnteckningarService);

    private selectionSubscription: Subscription;

    arbetsorderAnteckningVirkesorderUpdated = () => {
        this.arbetsorder.commandManager.updateCommand(new SetArbetsorderAnteckningVirkesorderCommand((instance) => {
            instance.arbetsorderId = this.arbetsorder.id;
            instance.anteckningVirkesorder = this.arbetsorder.anteckningVirkesorder;
        }));
    };

    getBeteckningarFromAtgarder = (atgarder: IAtgard[]): string => atgarder.map(p => p.beteckning).join(", ");

    isDetailEditable = () => this.arbetsorder.isEditableForMode(ArbetsorderDisabledFlag.makulerad);

    ngOnDestroy(): void {
        this.selectionSubscription.unsubscribe();
    }

    ngOnInit(): void {
        this.selectionSubscription = this.arbetsorderInfoAnteckningarService.selectionChanged.subscribe((obj: ArbetsorderInfoAnteckningSelection) => {
            this.arbetsorder = obj.arbetsorder;
            this.anteckningar = obj.arbetsorderAnteckningar;
        });
    }

    updateAOAnteckningProduktionsplanering = () => {
        this.arbetsorder.commandManager.addOrUpdate(new UpdateArbetsorderAnteckningProdplanCommand(c => {
            c.arbetsorderGuid = this.arbetsorder.guid;
            c.anteckning = this.arbetsorder.anteckningProduktionsplanering;
        }), command => command.arbetsorderGuid === this.arbetsorder.guid);
    };
}
